import {updateQueryStringParam} from "../Utils/Utils.js";

const ACFBlockStories = (domEl) => {

	const categorySelection = domEl.querySelector('#category-selection');
	if(!categorySelection) {
		return;
	}

	const newsItems = domEl.querySelectorAll('.news-item');

	const renderNewsItems = (category) => {
		newsItems.forEach(newsItem => {
			if(category === 'all') {
				newsItem.classList.add('js-active');
			}
			else {
				const categories = newsItem.dataset.categories;
				if(categories && categories.includes(category)) {
					newsItem.classList.add('js-active');
				}
				else {
					newsItem.classList.remove('js-active');
				}
			}
		});
	};

	const handleCategoryChange = (e) => {
		e.preventDefault();

		const category = e.currentTarget.value
		if(!category) {
			return;
		}

		// Get the options selected and update the urlParams
		if(history.pushState) {

			// Update the urlParams
			const uri = updateQueryStringParam('c', category);
			window.history.replaceState({path:uri},'',uri);
		}

		renderNewsItems(category);
	};

	categorySelection.addEventListener('change', handleCategoryChange);
};

export default ACFBlockStories;